import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { VendorsService } from 'src/app/_services/vendors.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { Paginator } from 'primeng/paginator';
import { GlobalService } from 'src/app/_services/global.service';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { FilterServiceService } from 'src/app/_services/filter-service.service';
import { BaseService } from 'src/app/_services/base.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-inventory-vendors',
  templateUrl: './inventory-vendors.component.html',
  styleUrls: ['./inventory-vendors.component.scss']
})
export class InventoryVendorsComponent implements OnInit {
  _globals = GlobalService
  @ViewChild('op') op: OverlayPanel

  first = 0
  page = 0
  rows = 10
  totalRecords = 0

  searchText = ''
  lastSearchText = ''
  dataList: any = null
  selectedRow: any = ''
  selectAll = false

  //order
  orderParam = ''
  orderBy = ''

  colheader = [[
    'Vendors', 'Company', 'Phone', 'Email', 'State', 'Status'
  ]];

  colflds = [
    'vendorName', 'company', 'phone', 'email', 'state', 'isActive'
  ];

  csvcols = []
  exportColumns: any = ''

  actions: MenuItem[] = [
    {
      label: 'Edit', icon: 'pi pi-book', command: () => {
        this.update();
      }
    },
    {
      label: 'Delete', icon: 'pi pi-trash', command: () => {
        this.delete();
      }
    },
  ]

  @ViewChild('p', { static: false }) paginator: Paginator;


  constructor(
    private _bs: BaseService,
    public _vendorService: VendorsService,
    private _spinner: NgxSpinnerService,
    private _connMessageService: ConnMessageService,
    private _confirmationService: ConfirmationService,
    public _abd: AppBaseDataService,
    public _filterService: FilterServiceService,
  ) { }

  ngOnInit(): void {
  }

  ngAfterViewInit() {
    let ti = null
    ti = setInterval(() => {
      //--
      this._globals.componentName = 'Vendors'
      this._globals.showProductDelButton = false

      let ppages = this._filterService.getPages(this._globals.componentName)
      if (ppages) {
        let lastpage = parseInt(ppages.page)
        if (lastpage < 0) lastpage = 0
        if (lastpage > 0) {
          this.page = lastpage
          this.first = lastpage * this.rows
        }
      }

      let filter = this._filterService.getFilters(this._globals.componentName)
      if (filter) {
        if (filter.searchText) {
          this._filterService.searchText = filter.searchText
          this.searchText = filter.search
        }
      }

      let oorderby = this._filterService.getOrderby(this._globals.componentName)
      if (oorderby) {
        this.orderParam = oorderby.orderParam
        this.orderBy = oorderby.orderBy
      }

      this.getDataList()
      //--
      clearInterval(ti)
    }, 200);
  }

  ngOnDestroy() {
    this._globals.componentName = ''
  }

  refreshData() {
    try {
      this._globals.showProductDelButton = false
      this._vendorService.isViewOnly = false
      this._vendorService.showNewEdit = false
      const loc = this._abd.vendors.filter(f =>
        (!f.isDeleted && f.isActive)
      )
      this.uncheckAll()
      this._globals.showProductDelButton = false
      this.totalRecords = loc.length
      this._abd.initVendors(loc)
    } catch {
      //console.log('ERROR-999')
      this._abd.loadInit()
    }
  }

  makeParams() {
    let params = new HttpParams();

    this.page = this.page < 1 ? 0 : this.page
    this.rows = this.rows < 1 ? 10 : this.rows

    params = params.append('pageNo', this.page.toString());
    params = params.append('pageSize', this.rows.toString());
    if (this.searchText.length) params = params.append('filterValue', this.searchText);

    return params
  }

  getDataList() {
    try {
      this._spinner.show()
      this.searchText = this._filterService.searchText
      let params = new HttpParams();

      this.page = this.page < 1 ? 0 : this.page
      this.rows = this.rows < 1 ? 10 : this.rows

      params = params.append('pageNo', this.page);
      params = params.append('pageSize', this.rows);
      if (this.searchText) params = params.append('filterValue', this.searchText)

      const outfilter = {
        searchText: this.searchText ? this.searchText : '',
      }

      this._filterService.updateFilters(this._globals.componentName, outfilter)
      this._filterService.updatePages(this._globals.componentName, { page: this.page, rows: this.rows })

      let qryParas = null
      if (this.orderParam && this.orderParam.length > 0) {
        qryParas = `?orderParam=${this.orderParam}&orderBy=${this.orderBy}`
        this._filterService.updateOrderby(this._globals.componentName, { orderParam: this.orderParam, orderBy: this.orderBy })
      }

      let url = environment.InventoryBaseURL + environment.VendorURL
      if (qryParas) url += qryParas

      return this._bs.httpGetParams(url, params).subscribe(res => {
        this._spinner.hide()
        if (res.success) {
          this.totalRecords = res.totalRecords
          this.dataList = res.data
        }
        for (let i = 0; i < this.dataList.length; i++)
          this.dataList[i].selected = false
        return res.data
      })
    } catch { this._spinner.hide() }
  }

  update() { }

  delete() { }

  clearSearchText() {
    this.searchText = ''
    this.lastSearchText = ''
    this._filterService.searchText = ''
    this.filterButtonPressed()
  }

  searchTextSearch() {
    if (this.searchText === this.lastSearchText) return

    this.lastSearchText = this.searchText
    this.filterButtonPressed()
  }

  implementLocalFilter() {
    this.page = 0
    this.getDataList()
  }

  callbackFuncFromFilter(event) {
    //
    this.implementLocalFilter()
    // this.getDataList()
  }

  filterButtonPressed() {
    this.page = 0
    this.implementLocalFilter()
  }

  onPageChange(e) {
    e.totalRecords = this.totalRecords
    this.rows = e.rows
    this.page = e.page

    this.getDataList()
  }

  addNewFn(e) {
    if (e !== 'vendor') return
    this._vendorService.showNewNewEdit = true
  }

  refreshFn(e) {
    this.getDataList()
  }

  refreshMotherData() {
    this.searchText = ''
    this.page = 0
    this._abd.getAllVendors()
  }

  uncheckAll() {
    for (let i = 0; i < this.dataList.length; i++) {
      this.dataList[i].selected = false
    }
  }

  selectAllChanged(event) {
    for (let i = 0; i < this.dataList.length; i++)
      this.dataList[i].selected = event.checked

    this._globals.showProductDelButton = event.checked
  }

  selectionChanged(event) {
    let ret = false
    if (!event.checked) {
      this.selectAll = this.selectAll ? !this.selectAll : this.selectAll
    }

    for (let i = 0; i < this.dataList.length; i++)
      if (this.dataList[i].selected) {
        ret = true
        break
      }

    if (event.checked) {
      const sel = this.dataList.filter(f => f.selected)
      if (sel.length == this.dataList.length) this.selectAll = true
      else this.selectAll = false
    }

    this._globals.showProductDelButton = ret
  }

  deleteMultipleItem() { }

  commaSeperatedIds(): string {
    let selectedItems: string = "";
    let z = this.dataList.filter(x => x.selected)
    z.forEach(x => { selectedItems += x.id + "," })
    selectedItems = selectedItems.slice(0, -1);
    return selectedItems
  }

  optionDeleteClicked() {
    this.op.hide()
    let selectedItems = ''
    let marked = this.dataList.filter(f => f.selected)

    if (marked.length < 1)
      selectedItems = this._vendorService.activeItem.id
    else
      selectedItems = this.commaSeperatedIds();

    this._confirmationService.confirm({
      message: 'Deleting process causes permanent loss of information. Are you sure to proceed',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this._abd.showSpinner()
        try {
          this._vendorService.deleteVendor(selectedItems).subscribe(res => {
            this._abd.hideSpinner()
            if (res.success) {
              this._globals.showProductDelButton = false
              this.refreshMotherData()
              this.getDataList()
              this._connMessageService.showToastMessage(`Vendor "${this._vendorService.activeItem.vendorName}" deleted!`, 'success')
            }
          })
        } catch {
          this._abd.hideSpinner()
        }
      },
      reject: () => { }
    });
  }

  actionButtonClick(item: any) {
    this._vendorService.activeItem = item
    this._vendorService.isViewOnly = false

  }

  getStateDisplay(item: any): string {
    const candidates = [
      item?.stateName,
      item?.StateName,
      item?.state,
      item?.State
    ]

    for (const candidate of candidates) {
      const text = String(candidate ?? '').trim()
      if (!text) continue
      const normalized = text.toLowerCase()
      if (normalized === 'unknown' || normalized === 'n/a' || normalized === 'na' || normalized === 'null' || normalized === 'undefined') {
        continue
      }
      return text
    }

    return '-'
  }

  exportExcel() {
    let data = [];
    this._abd.vendorsBS$.subscribe(res => {
      data = res;
    })
    this._abd.exportExcel(data, this.colheader[0], this.colflds, 'Vendor Report')
  }

  exportPdf() {
    let data = [];
    this._abd.vendorsBS$.subscribe(res => {
      data = res;
    })


    this._abd.exportPdf(
      data,
      this.colheader,
      this.colflds,
      'Vendor Report',
      false,
      false,
      false
    )
  }

  onRowSelect(e) {
    try {
      const el = e.originalEvent.srcElement.className
      if (el && el.includes('p-checkbox')) return
    } catch { }

    this._vendorService.activeItem = JSON.parse(JSON.stringify(e.data))
    this._vendorService.isViewOnly = true
    this._vendorService.showNewEdit = true
  }

  onRowUnselect(e) {
  }

  customSort(e) {
    const last = this.orderParam

    switch (e.sortField) {
      case 'vendorName':
        this.orderParam = 'vendorName'
        break;
      default:
        this.orderParam = ''
    }

    if (this.orderParam !== '') {
      this.orderBy = e.sortOrder == 1 ? 'asc' : 'desc'
      if (last !== this.orderParam) this.orderBy = 'asc'
      this.getDataList()
    }
  }


}
